<template>
  <button type="button" class="trix-button" :title="buttonText" tabindex="-1" @click="$emit('click')">
    {{ buttonText }}
  </button>
</template>

<script>
export default {
  props: {
    buttonText: {
      type: String,
      required: true
    }
  },

  emits: ['click']
}
</script>
